import React from "react"

import {ConditionType} from "../../../../../model2/conditions/condition-types"
import FieldsFactory from "../../../../fields-factory"
import {FieldType} from "../../../../field-type"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"
import SelectParentNew from "../../../../../gd-ui/select-parent-new/select-parent-new"
import FieldProject from "../project"
import {FieldConditionFormProps, FieldConditionRenderMode} from "../../../../render/condition/@types"
import Filter from "../../../../../manager/filters/manager/filter"
import ProjectSession from "../../../../../model2/project/project-session"
import ProjectSessionCollection from "../../../../../model2/project/collection"

// const debug = "FieldProject_ConditionForm"
const debug = false

export default function FieldProject_ConditionForm(props:FieldConditionFormProps) {

    const onChangeType = (conditionType: ConditionType) => {
        props.condition.type = conditionType
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const onChangeValue = (value: any) => {
        props.condition.value = value
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const getAvailableProjects = async (): Promise<ProjectSessionCollection> => {
        let availableProjects: ProjectSessionCollection = new ProjectSessionCollection([])

        switch (props.renderMode) {
            case FieldConditionRenderMode.FILTER_ITEMS_COLLECTION:
            case FieldConditionRenderMode.FILTER_COLLECTION:
                const filter = props.condition as Filter
                const valuesSet = await filter.collectValuesSet()

                // Process the values set to create available projects collection
                if (valuesSet) {
                    const projects: ProjectSession[] = []

                    // Map project IDs to ProjectSession objects
                    _.map([...valuesSet], (projectId: ID) => {
                        const project = gd.session.projects.get(projectId)
                        if (project) {
                            projects.push(project)
                        }
                    })

                    // Create collection from found projects
                    availableProjects = new ProjectSessionCollection(projects)
                }

                break

            case FieldConditionRenderMode.CONDITION:
            default:
                // doesnt apply
                break
        }

        return availableProjects
    }

    let field: FieldProject | null | false = null

    switch (props.condition.type) {
        case ConditionType.INCLUDES:
        case ConditionType.EXCLUDES:
            field = FieldsFactory.get({
                type    : FieldType.PROJECTS, // Field project used Field projects for filters
                fieldId : 'value'
            }) as FieldProject
            break
        default:
            break
    }

    debug && console.log(debug, 'render', props)

    return (
        <>
            <ConditionTypeSelector field    = {props.field}
                                   value    = {props.condition.type}
                                   onChange = {onChangeType}/>

            {field &&
                <div className="flex-row-left-center m-l-10">
                    <SelectParentNew className                  = "w-250 flex-no-shrink"
                                     projectId                  = {props.condition.value}
                                     parentsFor                 = {field.parentsFor}
                                     placeholder                = {field.placeholder}
                                     displayWorkspaceRoot       = {field.displayWorkspaceRoot}
                                     getAvailableProjects       = {getAvailableProjects}
                                     renderType                 = {SelectParent_RenderType.FORM}
                                     onChange                   = {(projectId:ID) => {onChangeValue(projectId || null)}}/>
                </div>
            }
        </>
    )
}
